// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".razon-social[data-v-508b7791]{\n  font-size:108%;\n  font-weight: 400;\n}\n.rut-receptor[data-v-508b7791]{\n  font-size:90%;\n  font-weight: 400;\n}\n[dir=ltr] .rut-receptor[data-v-508b7791]{\n  margin-left: 15px;\n}\n[dir=rtl] .rut-receptor[data-v-508b7791]{\n  margin-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
